export default "__VITE_ASSET__B8d9Bxld__"